<template>
    <div class="container mb-2">
        <div class="d-flex justify-content-center">
            <p class="m-3 w-custom-text">Za vozila vestno in odgovorno poskrbimo pred vsako vožnjo. 
            Vedno vas bomo pričakali s čistim in brezhibnim vozilom.
            Poudarjamo, če so voznik in vozila primerna in urejena, 
            so tudi stranke srečne in zadovoljne.
            </p>
        </div>
        <h2 class="text-start offset-md-2 offset-1 mt-3 mb-3 fw-bold">VOZILA</h2>
        <VehiclesCards/>
    </div>
</template>

<script>
import VehiclesCards from '../components/VehiclesCards.vue';
    export default {
        name: "Vehicles",
        components:{
            VehiclesCards
        }
    };
</script>